import { type CarrierDef } from '../common.js'
import { apiKey, password, username, userPassMap } from '../internal.js'

const credentialTypes = [username, password, apiKey] as const
const locationCredentialTypes = ['service-id'] as const

export type vsxpCredType =
  | (typeof credentialTypes)[number]
  | (typeof locationCredentialTypes)[number]

export const vsxp: CarrierDef<vsxpCredType> = {
  name: 'Vision Express Wrag-Time Transportation',
  scac: 'vsxp',
  credentialTypes,
  locationCredentialTypes,
  legacyCredMap: [
    ...userPassMap,
    ['api-key', 'apiKey'],
    ['service-id', 'ref1'],
  ],
  engineLayers: ['rating', 'pickup', 'tracking'],
}
